import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import qs from 'query-string'
import { QS_CONFIG } from '../../../features/common/Utilities'
import { ErrorAction, SuccessAction } from 'common/redux/toasts';

export async function deleteAuto(id, queryParamsObj) {
  try{
    const query = queryParamsObj
      ? '?'.concat(qs.stringify(queryParamsObj, QS_CONFIG))
      : ''
    const response = await axios.delete(`${CATALOGO_ENDPOINT}/${id}${query}`)
    SuccessAction({
      title: 'Producto eliminado con éxito'
    })
    return response
  }catch(error){
    ErrorAction({ title: error.response.data.message || "Hubo un error. No se pudo eliminar el producto." });
  }
}
